import React, { useEffect } from "react";
import parse from 'html-react-parser';

export const DynamicHtmlComponent = ({html, css}) => {
    //EFFECTS
    useEffect(() => {
        const styleElement = document.createElement('style');
        styleElement.textContent = css;
        document.head.appendChild(styleElement);
        return () => {
            document.head.removeChild(styleElement);
        };
    }, [css]);

    useEffect(() => {
        parse(html, {
            transform(reactNode, domNode, index) {
                if (reactNode.type === "script") {
                    try {
                        window.eval(domNode?.children[0]?.data);
                    } catch (e) {
                        console.log("Script error: ", e);
                    }
                }
            }
        });
    }, []);

    const transform = (reactNode, domNode, index) => {
        if (reactNode.type === "script") {
            return <script src={domNode?.attribs?.src}></script>;
        }
        else if (domNode?.attribs?.onclick) {
            const onClickCode = domNode.attribs.onclick;
            return React.createElement(
                reactNode.type,
                {
                    ...domNode.attribs,
                    onClick: () => {
                        try {
                            // Safely execute the onclick code
                            window.eval(onClickCode);
                        } catch (e) {
                            console.log("Error executing onClick: ", e);
                        }
                    }
                },
                reactNode.props.children
            );
        }
        else {
            return <>{reactNode}</>
        }
    }

    return (
        <>
            {parse(html, {transform})}
        </>
    );
}